/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { CurrencyEnum } from "@/lib/enum/currency.enum";

/**
 * @param currency
 * @returns
 */
export function formatCurrency(value: number, currency: CurrencyEnum, maximumFractionDigits?: number) {
  if (!value) value = 0;

  return Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: currency,
    ...(maximumFractionDigits !== undefined ? { maximumFractionDigits } : {})
  }).format(value);
}
